module.exports = __webpack_public_path__ + "img/21 Century.8dfcf672.svg";